import type { CommercePagesProject } from '@eliadmin/core/src/constants/commerce-pages-config';

export const COMMERCE_PAGES_PROJECT: CommercePagesProject = {
  "storefront": true,
  "customer": {
    "registration": {
      "company": false,
      "billing": false,
      "delivery": false
    },
    "profile": {
      "bank": true,
      "avatar": true,
      "gender": true,
      "copyBillingToDelivery": false
    },
    "orders": {
      "filters": false,
      "search": false
    },
    "favorites": {
      "guest": true,
      "bulk": false
    }
  },
  "blog": {
    "listing": {
      "search": true,
      "categories": "chips"
    }
  }
};
